import classes from './CtaOneColumnBlock.module.scss';
import Markdown from 'markdown-to-jsx';
import Button from '../../atoms/button/Button';

export default function CtaOneColumnBlock(props) {
    /**
     * Component expects props at object key 0
     */
    if (!props[0]) return null;
    const {
        0: ComponentContentSiteCopy,
        1: ComponentListCtaList,
        2: ComponentContentCopy,
        3: ComponentFieldSiteBackgroundImage,
        4: ComponentContentCardTheme
    } = props;

    const extenderClass = 'inlineCta';

    return (
        <div
            className={`${classes.oCtaOneColumn} ${
                classes[ComponentContentCardTheme.custom_class]
            }`}
            style={{
                backgroundImage: `url(${ComponentFieldSiteBackgroundImage?.background_image?.data?.attributes.url})`
            }}
        >
            <div className={`${classes.oContainer} container`}>
                <div className={`${classes.oRow} row`}>
                    <div className={`${classes.oColMain} col-12`}>
                        <h2 className={`${classes.aTitle} fnt32`}>
                            {ComponentContentSiteCopy.title}
                        </h2>
                        <Markdown className={`${classes.aCopy} fnt13f`}>
                            {ComponentContentSiteCopy?.copy}
                        </Markdown>
                    </div>
                    <div className={`${classes.oColCtas} col-12`}>
                        <div className={`${classes.mCtaList} mCtaList`}>
                            {ComponentListCtaList.next_steps_ctas.map((cta) => {
                                return (
                                    <Button
                                        key={cta.id}
                                        url={cta.href}
                                        style={`btnAlt${cta.id}`}
                                        extenderClass={extenderClass}
                                        {...cta}
                                    />
                                );
                            })}
                        </div>
                    </div>
                    <div className={`${classes.oColText} col-12`}>{ComponentContentCopy?.copy}</div>
                </div>
            </div>
        </div>
    );
}
